import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { ISmartResult } from '@/models/iris/smartMission/ISmartResult'
import { arrayToDataScienceArr } from '@/models/alo/AloMission'


export default {  
  getMissionVirtuals(): AxiosPromise<AlrContainer<AloBaseArray<AloDbMissionVirtual>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/missionvirtual', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMissionVirtual>>(JSON.parse(data),AloDbMissionVirtual.createAloDbMissionVirtualArray)
      }]
    })
  },
  getMissionVirtual(id:number):AxiosPromise<AlrContainer<AloDbMissionVirtual>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/missionvirtual/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbMissionVirtual>(JSON.parse(data),AloDbMissionVirtual.createAloDbMissionVirtualWithDetail)
      }]
    })
  },
  saveMissionVirtual(missionVirtual:AloDbMissionVirtual):AxiosPromise<AlrContainer<AloDbMissionVirtual>> {
    if(missionVirtual.id && missionVirtual.id > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/missionvirtual/${missionVirtual.id}`, 
        method: 'PUT',
        data: missionVirtual,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMissionVirtual>(JSON.parse(data),AloDbMissionVirtual.createAloDbMissionVirtualWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/missionvirtual`, 
        method: 'POST',
        data: missionVirtual,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMissionVirtual>(JSON.parse(data),AloDbMissionVirtual.createAloDbMissionVirtualWithDetail)
        }]
      })    
    }
    
  },
  deleteMissionVirtual(id:number):AxiosPromise<AlrContainer<AloDbMissionVirtual>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/missionvirtual/${id}`, 
      method: 'DELETE',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })       
  },
  getMissionResult(id:number) {
    return  apiHelpers.apiCall({ 
      url: `/api/iris/irisRequestingSimulator/${id}`, 
      method: 'GET',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<ISmartResult>(JSON.parse(data),(data)=>data)
      }]
    })    
  },  
  getDataScience(id:number,targetYosCycles:Array<number>|null):AxiosPromise<AlrContainer<Array<any>>>{    
    return  apiHelpers.apiCall({ 
      url: `api/mesurevirtual/${id}`, 
      method: 'GET',
      params: {targetYosCycles:targetYosCycles && targetYosCycles.length<=20?targetYosCycles.join(','):null},
      transformResponse: [function (data:string) {          
        return new AlrContainer<Array<any>>(JSON.parse(data),arrayToDataScienceArr)
      }]
    })              
  },
  updateStatus(id:number,vimStatus:number):AxiosPromise<AlrContainer<string>>{    
    return  apiHelpers.apiCall({ 
      url: `api/missionvirtual/${id}/vimstatus`, 
      method: 'PUT',
      data:{
        vimStatus
      },
      transformResponse: [function (data:string) {          
        return new AlrContainer<Array<string>>(JSON.parse(data),(data)=>data)
      }]
    })              
  },
}